<template>
  <div>
    <div class="con-tab-ejemplo" v-if="payments">
      <div class="vx-row">
        <div class="vx-col w-full vx-coll-fixed-hight">
          <vs-table :data="payments">
            <template slot="thead">
              <vs-th>{{ $t('sections.accounting.dataForm.tablePayment.no') }}</vs-th>
              <vs-th>{{ $t('sections.accounting.dataForm.tablePayment.paymentDate') }}</vs-th>
              <vs-th>{{ $t('sections.accounting.dataForm.tablePayment.paymentAmount') }}</vs-th>
              <vs-th>ประเภทการชำระ</vs-th>
              <vs-th>{{ $t('sections.accounting.dataForm.tablePayment.adjustment') }}</vs-th>
              <vs-th></vs-th>
            </template>
            <template slot-scope="{data}" >
              <vs-tr :key="index" v-for="(res, index) in data">
                <vs-td :data="(index+1)">
                  {{ (index+1) }}
                </vs-td>
                <vs-td :data="res.paymentDate">
                  {{ res.paymentDate | convYYYYMMDDToDDMMYYYY}}
                </vs-td>
                <vs-td :data="res.paymentAmount">
                  <a @click="paymentDetails(res)" class="cursor-pointer">{{ res.paymentAmount | numberFormat }}</a>
                </vs-td>
                <vs-td :data="res.paymentType">
                  <span v-html="paymentTypeName(res)"></span>
                </vs-td>
                <vs-td :data="res.adjustment">
                  <feather-icon :icon="res.adjustment ? 'CheckIcon' : 'MinusIcon'" :class="res.adjustment ? 'text-success' : 'text-black'"></feather-icon>
                </vs-td>
                <vs-td>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete" @click="delPayment(res.id)" v-show="!isHideDelPayment(res)"></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import moment from 'moment/moment';
const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');
import { round } from '@/utils'

export default {
  data () {
    return {
      refreshTransaction: false
    }
  },
  props: ['manage', 'paymentExtra'],
  async created() {

  },
  computed:{
    ...mapAccountingState([
      'status',
      'contract',
      'payments',
    ]),
  },
  methods: {
    ...mapAccountingActions([
      'getContract',
      'getTransactionsByContractIdRefresh',
      'deletePayment',
      'createPaymentContractFee',
      'createPaymentTaxAmount',
    ]),
    paymentTypeName(res) {
      const { qrPayment, paymentType } = res;
      let typeName = "";
      let name = "";
      if (paymentType === "Operator"){
        typeName = "โอนชำระ"
      }else if(paymentType === "QRCode"){
        typeName = "QR CODE"
      }else {
        typeName = ""
      }
      if (qrPayment !== null){
        const { type } = qrPayment;
        if ( type === "normal"){
          name = "ปกติ";
        }else if (type === "custom"){
          name = "กำหนดเอง";
        }else if (type === "outstanding"){
          name = "ชำระยอดค้าง";
        }else if (type === "close"){
          name = "ชำระแบบปิดบัญชี";
        }else{
          name = "ปกติ";
        }
        return `${typeName} <small style="color: gray">(${name})</small>`;
      } else {
        return `${typeName}`;
      }
    },
    paymentDetails(res) {
      let text= ""
      let prefix = ""
      const { createdBy: user, createdAt, transaction } = res
      const { paidAccruedFee, paidAccruedPenalty, paidAccruedInterest, paidPrinciple } = transaction
      if(user.prefix){prefix = user.prefix.nameTh}
      let createdByUser = prefix+user.name+" "+user.surname
      if(res.transaction) {
        text = `ยอดชำระค่าธรรมเนียม: ${round(paidAccruedFee, 2)} บาท\nยอดชำระดอกเบี้ยปรับ: ${round(paidAccruedPenalty, 2)} บาท\nยอดชำระดอกเบี้ย: ${round(paidAccruedInterest, 2)} บาท\nยอดชำระดอกเบี้ยล่วงหน้า: ${round(transaction.balanceRemain, 2)} บาท\nยอดชำระเงินต้น: ${round(paidPrinciple, 2)} บาท\n\nผู้บันทึก: ${createdByUser}\nวันที่: ${this.convFormatDateTime(createdAt)}`
      }
      alert(text)
    },
    async delPayment (id) {
      const vm = this
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: vm.acceptDelPayment
      })
    },
    async acceptDelPayment () {
      await this.deletePayment({
        form: {
          id: this.actionID
        },
        vm: this
      })
      if(this.refreshTransaction){
        this.refreshTransaction = false
        await this.getTransactionsByContractIdRefresh({contractId: this.$route.params.id})
      }
    },
    async addPaymentContractFee () {
      const vm = this
      vm.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการชำระค่าธรรมเนียมการทำสัญญา',
        text: 'ต้องการที่จะชำระค่าธรรมเนียมการทำสัญญา?',
        accept: vm.acceptAddPaymentContractFee
      })
    },
    async acceptAddPaymentContractFee () {
      await this.createPaymentContractFee ({
        contractId: this.$route.params.id,
      });
      await this.getContract({form: {id: this.$route.params.id}});
    },
    async addPaymentTaxAmount () {
      const vm = this
      vm.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันการชำระค่าอากรแสตมป์',
        text: 'ต้องการที่จะชำระค่าอากรแสตมป์?',
        accept: vm.acceptAddPaymentTaxAmount
      })
    },
    async acceptAddPaymentTaxAmount () {
      await this.createPaymentTaxAmount ({
        contractId: this.$route.params.id,
      });
      await this.getContract({form: {id: this.$route.params.id}});
    },
    isHideDelPayment (res){
      return !(!res.transaction && this.manage && res.paymentType !== 'QRCode');

    },
    convFormatDateTime(val){
      return `${moment(val).format("วันที่ DD-MM-YYYY เวลา HH.mm น.")}`
    },
  },
}
</script>

<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:515px;
    overflow: auto;
  }
</style>
